module.exports = __webpack_public_path__ + "static/tlo_glowna-9f2d574c9d2f3f2d58211554a0754a7d.jpg";